import type { DefineFlags } from '@ms-cloudpack/common-types-browser';

/**
 * Shared CLI options for all commands.
 */
export interface SharedOptions {
  /**
   * Whether to enable debug logging (superset of --verbose).
   */
  debug?: boolean;

  /**
   * Whether to enable verbose logging.
   */
  verbose?: boolean;

  /**
   * Whether to enable colors. Available on the command line as `--no-color`.
   */
  color?: boolean;

  /**
   * Whether to disable non-essential logging.
   */
  quiet?: boolean;

  /**
   * Experimental features to enable.
   */
  features?: Record<string, boolean>;

  /**
   * Custom cache folder to use for this run of the command.
   */
  cachePath?: string;

  /**
   * Key value pairs that will be used to define global variables in the runtime.
   */
  define?: DefineFlags;

  /**
   * Write log file with all console output.
   */
  logFile?: boolean;

  /**
   * Custom config file name to use instead of cloudpack.config.json.
   */
  config?: string;
}
